export const checkQrRequirementsColor = (qr, purchaseOrderQr) => {
  if (!qr || !purchaseOrderQr) return 'success'
  const splitted = qr.split(':')[1].split(';')
  let color = 'success'
  for (let i = 0; i < splitted.length; i++) {
    if (purchaseOrderQr[i] === 0 || purchaseOrderQr[i] === '0') {
      continue
    }
    if (splitted[i] === null || splitted[i] === '') {
      color = 'yellow'
    }
    if (splitted[i] === 0 || splitted[i] === '0') {
      color = 'red'
    }
  }
  return color
}

export const updateQr = (oldQr, newValue, index) => {
  if (!oldQr) return ''

  const split = oldQr.split(':')
  const version = split[0]
  const valuesStr = split[1] || ''

  const values = valuesStr === '' ? [] : valuesStr.split(';')

  while (values.length <= index) {
    values.push('')
  }
  values[index] = newValue
  return version + ':' + values.join(';')
}
